import { type Permission } from '~/domain/users/models/permission.ts';
import { cn } from '~/styles/extended-theme.ts';

import { AdminSidebarLinks } from './admin-sidebar-links.tsx';

export function AdminSidebar({ permissions }: { permissions?: Permission[] }) {
  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 top-0 flex w-12 flex-col justify-between bg-gray-200 pt-16 text-gray-400',
      )}
    >
      <div className="w-full text-white">
        <div className="flex flex-col">
          <AdminSidebarLinks userPermissions={permissions} />
        </div>
      </div>
    </div>
  );
}
